import { render, staticRenderFns } from "./TabelaValoresMT.vue?vue&type=template&id=81ab4df2"
import script from "./TabelaValoresMT.vue?vue&type=script&lang=js"
export * from "./TabelaValoresMT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports